import { useFormContext } from "react-hook-form";
// import ErrorMessage from "components/atoms/forms/ErrorMessage";
// import { useUserContext } from "components/context/UserContext";
import InputFieldWithLabel from "../molecules/forms/InputFieldWithLabel";
import TextAreaWithLabel from "../molecules/forms/TextAreaWithLabel";

type Props = {
  labelClasses?: string;
  gapY?: number;
  additionalClasses?: string;
  isEditForm?: boolean;
};

function BrandDetailsForm({ labelClasses = "", gapY = 5, additionalClasses = "", isEditForm }: Props) {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  // const { userDetails, setupUserAccountAndAirDropMagnet } = useUserContext();

  return (
    <div className={`flex flex-col gap-y-${gapY}`}>
      <div className="w-full md:w-9/12 ">
        <InputFieldWithLabel
          additionalClasses={additionalClasses}
          labelClasses={labelClasses}
          label="Brand Name*"
          id="name"
          register={register}
          placeHolder="Enter your Brand Name"
          defaultValue=""
          isDisabled={isEditForm}
          // @ts-ignore
          errorMessage={errors?.name?.message}
        />
      </div>
      <div className="w-full">
        <TextAreaWithLabel
          additionalClasses={additionalClasses}
          labelClasses={labelClasses}
          label="About*"
          id="about"
          rows={5}
          placeHolder="Tell us about the brand, this will show up on your brand page!"
          register={register}
          defaultValue=""
          // @ts-ignore
          errorMessage={errors?.about?.message}
        />
      </div>
      {/* {!userDetails?.is_dapper_setup && (
        <div className="w-8/12 font-satoshi">
          <div className="border-1 border-dashed border-neutral-400 border-opacity-50 bg-white bg-opacity-5 shadow sm:rounded-lg">
            <div className="sm-pb-4 px-4 py-3 sm:px-4 sm:pt-5">
              <h3 className="text-sm font-semibold leading-6 text-white">Link Dapper Wallet</h3>
              <div className="mt-1 max-w-xl text-xs font-medium text-gray-400">
                <p>Linking Dapper Wallet is Mandatory for Creating a Brand.</p>
              </div>
              <div className="mt-3">
                <button
                  onClick={setupUserAccountAndAirDropMagnet}
                  type="button"
                  className="inline-flex items-center rounded-md bg-[#9900f0] bg-opacity-90 px-3 py-2 text-xxs font-semibold text-white shadow-sm hover:bg-opacity-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#9900f0]"
                >
                  Link Wallet
                </button>
              </div>
              <ErrorMessage errorMessage={errors.root?.message} />
            </div>
          </div>
        </div>
      )} */}
    </div>
  );
}
export default BrandDetailsForm;
